import { JSX } from "react";

interface IProps {
  children: JSX.Element | string;
  className?: string;
}

function Card(props: IProps) {
  const { children, className } = props;
  return (
    <div
      className={`bg-white-transparent hover: sm:py-[28px] sm:px-[32px] py-[18px] px-[20px] rounded-xl sm:rounded-[20px] ${className}`}
    >
      {children}
    </div>
  );
}

export default Card;
